import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  Inject,
} from "@angular/core";
import { MatCheckboxChange, MatSnackBar } from "@angular/material";
import {
  EncomendaHistorico,
  EncomendasHistoricoRequest,
  PackageStatus,
} from "src/app/api";
import { PopoverPosition } from "@mandae/ng-popover";
import { maskString, TextFormats } from "@mandae/ng-utils/mask";
import { of } from "rxjs";
import { catchError, startWith, switchMap, tap } from "rxjs/operators";
import * as _ from "lodash";
import {
  PackageCourierTrackingCodeFilter,
  PackageStatusFilter,
  PackageTrackingCodeFilter,
  RecipientNameFilter,
} from "../../dashboard/common-filters";
import {
  ListingSearchFilter,
  ListingSearchType,
} from "../../dashboard/interfaces/listing-search-filter";
import { ListingBaseComponent } from "../../dashboard/listing-base.component";
import downloadFile from "../../download-file";
import { AuthService } from "../../services/ajs-auth.service";
import { UiRouterState } from "../../services/ajs-router-state.service";
import { StateParamsService } from "../../services/ajs-state-params.service";
import { PackageHistoryApiService } from "../../services/api/package-history-api.service";
import { ScreeningApiService } from "../../services/api/screening-api.service";
import { TourService } from "../../tour/tour.service";
import { FinancialApiService as FinancialService } from "./../../services/financial.service";
import { LocalStorageService } from "src/app/services/localstorage.service";
import { ClienteApiService } from "src/app/services/cliente.service";

@Component({
  selector: "mandae-package-list",
  templateUrl: "./package-list.component.html",
  styleUrls: ["./package-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageListComponent
  extends ListingBaseComponent<any>
  implements OnInit, AfterViewInit {
  public filters: ListingSearchFilter[] = [
    {
      displayType: ListingSearchType.Text,
      value: "cepDestinatario",
      viewValue: "CEP do destinatário",
      placeholder: "00000-000",
    },
    {
      displayType: ListingSearchType.Text,
      value: "chaveAcessoNfe",
      viewValue: "Chave de Acesso da NF-e",
      placeholder: "",
    },
    {
      displayType: ListingSearchType.Text,
      value: "cnpjDestinatario",
      viewValue: "CNPJ do destinatário",
      placeholder: "",
    },
    {
      displayType: ListingSearchType.Text,
      value: "cpfDestinatario",
      viewValue: "CPF do destinatário",
      placeholder: "",
    },
    PackageCourierTrackingCodeFilter,
    RecipientNameFilter,
    {
      displayType: ListingSearchType.Text,
      value: "numeroPedido",
      viewValue: "Número da coleta",
      placeholder: "OS123456/2019",
    },
    PackageTrackingCodeFilter,
    {
      displayType: ListingSearchType.Text,
      value: "referencia",
      viewValue: "Referência",
      placeholder: "Código do pedido na sua loja",
    },
    {
      displayType: ListingSearchType.Enum,
      value: "jaFoiImpressa",
      viewValue: "Situação da etiqueta",
      placeholder: "",
      options: [
        { value: null, viewValue: "Todas" },
        { value: "true", viewValue: "Etiquetas geradas" },
        { value: "false", viewValue: "Etiquetas não geradas" },
      ],
    },
    // PackageStatusFilter,
  ];

  public filtroSituacao: any = PackageStatusFilter.options;

  public pedidosNuvemShop: any = [];

  public nuvemshopReady = false;

  public data: EncomendaHistorico[] = [];
  public pages = 0;
  public loadingData = false;
  public displayedColumns = [
    "select",
    "codigo_rastreamento",
    "nome_destinatario",
    "envio",
    "previsao_entrega",
    "referencia",
    "situacao",
    "frete",
    "coleta",
    "acoes",
  ];

  public displayedColumnsGoPlus = [
    "select",
    "codigo_rastreamento",
    "nome_destinatario",
    "envio",
    "previsao_entrega",
    "referencia",
    "situacao",
    "frete",
    "acoes",
  ];

  private _selectAllChecked = false;
  public get selectAllChecked() {
    return this._selectAllChecked;
  }
  public set selectAllChecked(value: boolean) {
    if (value !== this._selectAllChecked) {
      this._selectAllChecked = value;

      if (value) {
        this.selectAllElements();
      } else {
        this.clearSelection();
      }
    }
  }

  private _selectAllIndeterminate = false;
  public get selectAllIndeterminate() {
    return this._selectAllIndeterminate;
  }
  public set selectAllIndeterminate(value: boolean) {
    if (value !== this._selectAllIndeterminate) {
      this._selectAllIndeterminate = value;
      this.changeDetectorRef.markForCheck();
    }
  }

  public get hasSelectedAnyElement() {
    return Object.keys(this.selectedElements).length > 0;
  }

  public downloadingLabels = false;

  public downloadingLabelsMassa = false;

  public selectedOrClearBtn = false;

  public showGerarOcorenButton = false;

  public readonly businessDaysMapping: { [k: string]: string } = {
    "=1": "1 dia útil",
    other: "# dias úteis",
  };

  private selectedElements: { [packageId: number]: EncomendaHistorico } = {};

  public user = [];

  constructor(
    private api: FinancialService,
    private apiNew: FinancialService,
    private orderApi: PackageHistoryApiService,
    private screeningApi: ScreeningApiService,
    private authService: AuthService,
    private changeDetectorRef: ChangeDetectorRef,
    private state: UiRouterState,
    private snackBar: MatSnackBar,
    private tour: TourService,
    private stateParams: StateParamsService,
    private lss: LocalStorageService,
    @Inject(ClienteApiService) private clienteService: ClienteApiService
  ) {
    super();

    this.searchParameters = {
      offset: 0,
      limit: 10,
    };

    this.filtroSituacao.map((situacao) => {
      situacao.check = true;
    });

    this.user = this.lss.get("user");
  }

  ngOnInit() {
    super.ngOnInit();

    const userId =
      (this.authService.getCurrentUser() &&
        this.authService.getCurrentUser().id) ||
      0;

    // Verificar se cliente tem Proceda Ocoren ativo
    this.checkClienteProcedaComOcorenHabilitado(userId);

    this.refresh
      .pipe(
        startWith({}),
        tap(() => {
          this.loading = true;
          this.changeDetectorRef.markForCheck();
        }),
        switchMap(() =>
          this.orderApi
            .getPackageHistory({
              ...this.searchParameters,
              ...this.filterParameters,
              clienteId: userId,
            })
            .pipe(catchError(() => of({ total: 0, pedidos: [] })))
        ),
        tap((data) => {
          this.data = _.sortBy(data.pedidos, "codigoRastreamento");

          this.data.map(async (encomenda: any) => {
            if (encomenda.codigoSituacao === "Entregue") {
              const comprovante = await this.verificarComprovante(encomenda);

              if (comprovante) {
                encomenda.comprovante = comprovante;

                this.changeDetectorRef.markForCheck();
              }
            }
          });

          this.pages = Math.ceil(data.total / this.searchParameters.limit);
          this.loading = false;
          this.changeDetectorRef.markForCheck();

          if (this.pedidosNuvemShop.length) {
            if (this.data.length === 0) {
              const pedidos = this.pedidosNuvemShop.includes(",")
                ? this.pedidosNuvemShop.split(",").join()
                : this.pedidosNuvemShop[0];
              this.snackBar.open(
                `Os pedidos ${pedidos} nÃ£o foram encontrados, por favor, importe os pedidos primeiro`,
                "Fechar",
                {
                  duration: 2500,
                }
              );
            }

            this.selectAllElements();

            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const acao = urlParams.get("acao");

            if (!this.nuvemshopReady) {
              if (acao === "gerarEtiquetas") {
                this.imprimirEtiquetasByNuvemshop();
              }

              this.nuvemshopReady = true;
            }
          }
        })
      )
      .subscribe();
  }

  ngAfterViewInit() {
    if (this.stateParams.tour) {
      this.startTour();
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pedidos = urlParams.get("pedidos");

    if (pedidos) {
      this.pedidosNuvemShop[0] = pedidos;
      if (pedidos.includes(",")) {
        this.pedidosNuvemShop = pedidos.split(",");
      }

      this.filterParameters.rastreamento = this.pedidosNuvemShop;
      this.aplicarFiltros();

      sessionStorage.removeItem("webapp.plataforma");
    }
  }

  isEmptyDatasource() {
    return !this.data || this.data.length === 0;
  }

  canSelectElement(element: EncomendaHistorico) {
    return [
      PackageStatus.Nova,
      PackageStatus.NaoColetada,
      PackageStatus.EmProcessamento,
    ].includes(element.codigoSituacao);
  }

  clearSelection() {
    this.selectedElements = {};
    this.updateSelectAllState();
    this.changeDetectorRef.markForCheck();
  }

  clearSelectionFilterSituantion() {
    this.selectedOrClearBtn = true;
    this.filtroSituacao.map((situacao) => {
      situacao.check = false;
    });
  }

  selectAllFilterSituantion() {
    this.selectedOrClearBtn = false;
    this.filtroSituacao.map((situacao) => {
      situacao.check = true;
    });
  }

  selectAllElements() {
    this.selectedElements = this.getSelectableElements().reduce(
      (acc, element) => {
        acc[element.id] = element;
        return acc;
      },
      {}
    );
    this.updateSelectAllState();
    this.changeDetectorRef.markForCheck();
  }

  elementSelected(element: EncomendaHistorico) {
    return this.selectedElements[element.id];
  }

  selectElement(element: EncomendaHistorico, ev: MatCheckboxChange) {
    if (!this.canSelectElement(element)) {
      ev.source.checked = false;
      return;
    }

    if (ev.checked) {
      this.selectedElements[element.id] = element;
    } else {
      delete this.selectedElements[element.id];
    }
    this.updateSelectAllState();
    this.changeDetectorRef.markForCheck();
  }

  getHrefForCollection(collection: number) {
    return this.state.href("pedido-detalhe", { idPedido: collection });
  }

  gotoCollection(collection: number) {
    this.state.go("pedido-detalhe", { idPedido: collection });
  }

  gotoTracking(code: string) {
    this.state.go("rastreamento", { numeroRastreio: code });
  }

  makeAddressFirstLine(element: EncomendaHistorico): string {
    return [
      maskString(element.destinatario.endereco.cep, TextFormats.cepMask),
      element.destinatario.endereco.cidade,
      element.destinatario.endereco.uf,
    ]
      .filter((x) => x)
      .join(" - ");
  }

  makeAddressSecondLine(element: EncomendaHistorico): string {
    return [
      element.destinatario.endereco.logradouro,
      element.destinatario.endereco.numero,
      element.destinatario.endereco.complemento,
    ]
      .filter((x) => x)
      .join(", ");
  }

  printLabels() {
    const packageIds = Object.keys(this.selectedElements).map((id) => +id);
    this.downloadingLabels = true;
    this.changeDetectorRef.markForCheck();

    this.screeningApi.getLabelsPDF(packageIds).subscribe(
      (response) => {
        const data = response.body;
        const mime = response.headers.get("content-type");
        const filename = `etiquetas.pdf`;
        downloadFile(data, mime, filename);
        this.downloadingLabels = false;
        this.clearSelection();
        this.refresh.next();
      },
      () => {
        this.downloadingLabels = false;
        this.snackBar.open("Não foi possível gerar as etiquetas", "Fechar", {
          duration: 2500,
        });
      }
    );
  }

  printLabelsEmLote() {
    const clienteId = this.authService.getCurrentUser().id;
    this.screeningApi.getLabelsEmMassaPDF(clienteId).subscribe(
      (response) => {
        const data = response.body;
        const mime = response.headers.get("content-type");
        const filename = `etiquetasEmLote.pdf`;
        downloadFile(data, mime, filename);
        this.downloadingLabelsMassa = false;
        this.clearSelection();
        this.refresh.next();
      },
      () => {
        this.downloadingLabelsMassa = false;
        this.snackBar.open("Não há etiquetas para serem geradas", "Fechar", {
          duration: 2500,
        });
      }
    );
  }

  public async imprimirEtiquetasByNuvemshop() {
    const packageIds = Object.keys(this.selectedElements).map((id) => +id);

    this.downloadingLabels = true;
    await this.screeningApi.getLabelsPDF(packageIds).subscribe(
      (response) => {
        const data = response.body;
        const mime = response.headers.get("content-type");
        const filename = `etiquetas.pdf`;
        this.downloadingLabels = false;
        this.loadingData = false;
        this.downloadingLabelsMassa = false;
        downloadFile(data, mime, filename);
      },
      () => {
        this.downloadingLabels = false;
        this.loadingData = false;
        this.downloadingLabelsMassa = false;
        this.snackBar.open("Não foi possível gerar as etiquetas", "Fechar", {
          duration: 2500,
        });
      }
    );
  }

  public applySearch(searchData) {
    if (searchData.searchBy === "cepDestinatario") {
      searchData.value = searchData.value.replace(/\D/g, "");
    }
    if (
      searchData.searchBy === "cnpjDestinatario" ||
      searchData.searchBy === "cpfDestinatario"
    ) {
      // CNPJ pode ser alfanumérico desde julho/2026 (IN RFB nº 2.229/2024).
      // Removemos apenas os separadores da máscara e normalizamos para uppercase.
      searchData.value = (searchData.value || "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    }
    // super.applySearch(searchData);
    this.filterParameters = [];

    if (searchData.valueStart || searchData.valueEnd) {
      this.filterParameters.dataInicio = searchData.valueStart;
      this.filterParameters.dataFim = searchData.valueEnd;
    }

    this.filterParameters[searchData.searchBy] = searchData.value;

    this.aplicarFiltros();
  }

  public aplicarFiltrosStatus() {
    const status = [];

    this.filtroSituacao.map((filtro) => {
      if (filtro.check) {
        status.push(filtro.value);
      }

      return;
    });

    this.filterParameters.situacaoPedido = `${status.join(",")}`;

    this.aplicarFiltros();
  }

  public downloadRelatorio() {
    const user = this.lss.get("user");

    const keys = Object.keys(this.filterParameters);
    const filtro = [];

    for (let i = 0; i < keys.length; i++) {
      const temp = `${keys[i]}=${this.filterParameters[keys[i]]}`;
      filtro.push(temp);
    }

    this.api.downloadRelatorio(user.id, filtro.join("&"), "encomenda");
  }

  async aplicarFiltros() {
    const user = this.lss.get("user");

    const keys = Object.keys(this.filterParameters);
    const filtro = [];

    for (let i = 0; i < keys.length; i++) {
      const temp = `${keys[i]}=${this.filterParameters[keys[i]]}`;
      filtro.push(temp);
    }

    this.loadingData = true;
    try {
      this.data = [];
      // const response: any = await this.apiNew.filtrosSituacaoEncomenda(
      //   user.id,
      //   this.searchParameters,
      //   filtro.length ? filtro.join("&") : ""
      // );

      // const data = JSON.parse(response);

      // this.data = _.sortBy(data.pedidos, "codigoRastreamento");
      // this.pages = Math.ceil(data.total / this.searchParameters.limit);

      this.refresh.next();

      // if (this.pedidosNuvemShop.length) {
      //   if (this.data.length === 0) {
      //     const pedidos = this.pedidosNuvemShop.includes(",")
      //       ? this.pedidosNuvemShop.split(",").join()
      //       : this.pedidosNuvemShop[0];
      //     this.snackBar.open(
      //       `Os pedidos ${pedidos} não foram encontrados, por favor, importe os pedidos primeiro`,
      //       "Fechar",
      //       {
      //         duration: 2500,
      //       }
      //     );
      //   }

      //   this.selectAllElements();

      //   const queryString = window.location.search;
      //   const urlParams = new URLSearchParams(queryString);
      //   const acao = urlParams.get("acao");

      //   if (!this.nuvemshopReady) {
      //     if (acao === "gerarEtiquetas") {
      //       this.imprimirEtiquetasByNuvemshop();
      //     }

      //     this.nuvemshopReady = true;
      //   }
      // }
    } catch (error) {
      console.log(error);
    }
    this.loadingData = false;
  }

  private getSelectableElements() {
    return this.data.filter((element) => this.canSelectElement(element));
  }

  private updateSelectAllState() {
    const selected = Object.keys(this.selectedElements);
    const selectable = this.getSelectableElements();

    this._selectAllIndeterminate = false;
    this._selectAllChecked = false;

    if (selected.length === 0) {
      this._selectAllChecked = false;
    } else if (selected.length < selectable.length) {
      this._selectAllIndeterminate = true;
    } else {
      this._selectAllChecked = true;
    }

    this.changeDetectorRef.markForCheck();
  }

  private startTour() {
    const steps = this.tour.makeTour([
      {
        title: "Gerencie suas encomendas",
        text: "Aqui você pode controlar e resolver as ocorrências, gerenciar devoluções e solicitar logística reversa.",
        attachTarget: () =>
          document.querySelector<HTMLElement>(
            '.menu-container a[href*="/historico"]'
          ),
      },
      {
        title: "Histórico de encomendas",
        text: "Confira todo o histórico de suas encomendas em processo de envio e enviadas pela Mandaê.",
        attachTarget: () =>
          document.querySelector<HTMLElement>(
            "app-toolbar .mat-tab-label-active"
          ),
      },
      {
        title: "Busca e filtro",
        text: "Busque pelo código ou filtre a tabela abaixo.",
        preferredPosition: PopoverPosition.Right,
        attachTarget: () =>
          document.querySelector<HTMLElement>(
            "mandae-listing-search .search-by.mat-form-field"
          ),
      },
      {
        title: "Rastreamento",
        text: "Através deste código, você poderá acompanhar o passo-a-passo de sua encomenda.",
        preferredPosition: PopoverPosition.Right,
        attachTarget: () =>
          document.querySelector<HTMLElement>(
            "td.mat-column-codigo_rastreamento a"
          ) || document.querySelector("th.mat-column-codigo_rastreamento"),
        next: {
          text: "Ir para Ocorrências",
          action: (ev, ref) => {
            ref.close("to_next_section");
            this.state.go("packages-list", { tour: true }, { inherit: false });
          },
        },
      },
    ]);

    this.tour.start(steps).subscribe();
  }

  public async verificarComprovante(encomenda) {
    try {
      const data: any = await this.clienteService.comprovanteEntrega(
        encomenda.id
      );

      return data.url;
    } catch (error) {
      return false;
    }
  }

    private async checkClienteProcedaComOcorenHabilitado(userId: number): Promise<void> {
    try {
      this.showGerarOcorenButton = await this.api.isClienteProcedaComOcorenHabilitado(userId);
    } catch (error) {
      console.error('Erro ao verificar cliente OCOREN:', error);
      this.showGerarOcorenButton = false;
    } finally {
      this.changeDetectorRef.markForCheck();
    }
  }

    public async sendGerarOcoren(): Promise<void> {
    if (!this.hasSelectedAnyElement) {
      return this.showSnackBar('Selecione ao menos uma encomenda para gerar OCOREN.', 2500);
    }

    const currentUser = this.authService.getCurrentUser();
    if (!currentUser.id) {
      return this.showSnackBar('Usuário não encontrado.', 2500);
    }

    try {
      const codigoRastreamentoRemessasLista = Object.values(this.selectedElements).map(item => item.codigoRastreamento);
      await this.api.gerarOcoren({ idCliente: currentUser.id, codigoRastreamentoRemessasLista });
      this.showSnackBar('OCOREN gerado com sucesso!', 2500);
    } catch (error) {
      console.error('Erro ao gerar OCOREN:', error);
      const errorMessage = this.extractErrorMessage(error);
      this.showSnackBar(errorMessage, 5000);
    }
  }

  private extractErrorMessage(error: any): string {
    const message = error.error.error.message || error.error.message || error.message || 'Erro ao gerar OCOREN. Tente novamente.';
    return message.replace(/^codigoRastreamentoRemessasLista:\s*/i, '');
  }

  private showSnackBar(message: string, duration: number): void {
    this.snackBar.open(message, 'Fechar', {
      duration,
      verticalPosition: 'top'
    });
  }
}
